export function setProducerEncodingsByQuality(encodings, quality) {
    const encodingParamsLength = encodings.length;
    encodings.forEach((encoding) => {
        switch (encoding.scaleResolutionDownBy) {
            case 1:
                encoding.active =
                    encodingParamsLength === 3
                        ? quality.high
                        : encodingParamsLength === 2
                            ? quality.mid
                            : quality.low;
                break;
            case 2:
                encoding.active = encodingParamsLength === 3 ? quality.mid : quality.low;
                break;
            default:
                encoding.active = quality.low;
                break;
        }
    });
}
//# sourceMappingURL=mediasoupUtils.js.map